import { Box, Flex } from '@chakra-ui/react';
import React from 'react';

import config from 'configs/app';
import useNavItems, { isGroupItem } from 'lib/hooks/useNavItems';
import RewardsButton from 'ui/rewards/RewardsButton';
import { CONTENT_MAX_WIDTH } from 'ui/shared/layout/utils';
import NetworkLogo from 'ui/snippets/networkLogo/NetworkLogo';
import NetworkSwitcher from 'ui/snippets/networkSwitcher/NetworkSwitcher';
import Settings from 'ui/snippets/topBar/settings/Settings';
import UserProfileDesktop from 'ui/snippets/user/profile/UserProfileDesktop';
import UserWalletDesktop from 'ui/snippets/user/wallet/UserWalletDesktop';

import NavigationPromoBanner from '../promoBanner/NavigationPromoBanner';
import RollupStageBadge from '../RollupStageBadge';
import ConnectWalletNavItem from './ConnectWalletNavItem';
import NavLink from './NavLink';
import NavLinkGroup from './NavLinkGroup';

const NavigationDesktop = () => {
  const { mainNavItems } = useNavItems();

  return (
    <Box
      borderColor={{ base: 'gray.200', _dark: 'whiteAlpha.200' }}
      borderBottomWidth="1px"
      position="sticky"
      top={ 0 }
      zIndex={ 100 }
      backdropFilter="blur(12px)"
      bg={{ base: 'rgba(255, 255, 255, 0.8)', _dark: 'rgba(20, 20, 20, 0.8)' }}
      boxShadow={{ base: '0 4px 30px rgba(0, 0, 0, 0.05)', _dark: '0 4px 30px rgba(0, 0, 0, 0.1)' }}
    >
      <Flex
        display={{ base: 'none', lg: 'flex' }}
        alignItems="center"
        gap={ 6 }
        px={ 8 }
        py={ 4 }
        maxW={ `${ CONTENT_MAX_WIDTH }px` }
        m="0 auto"
      >
        { /* Left: logo */ }
        <Flex alignItems="center" flexShrink={ 0 }>
          <NetworkLogo/>
          <RollupStageBadge ml={ 3 }/>
        </Flex>

        { /* Center: navigation links */ }
        <Flex as="nav" flex="1" minW={ 0 } justifyContent="center">
          <Flex as="ul" alignItems="center" columnGap={ 6 }>
            { mainNavItems.map((item) => {
              if (isGroupItem(item)) {
                return <NavLinkGroup key={ item.text } item={ item }/>;
              } else {
                return <NavLink key={ item.text } item={ item } noIcon py={ 2 } w="fit-content"/>;
              }
            }) }
          </Flex>
        </Flex>

        { /* Right: wallet, network, settings */ }
        <Flex alignItems="center" gap={ 3 } flexShrink={ 0 }>
          <NavigationPromoBanner/>
          { config.features.rewards.isEnabled && <RewardsButton size="sm"/> }
          <ConnectWalletNavItem/>
          { config.features.networkSwitcher.isEnabled && <NetworkSwitcher/> }
          <Settings/>
          {
            (config.features.account.isEnabled && <UserProfileDesktop buttonSize="sm"/>) ||
            (config.features.blockchainInteraction.isEnabled && <UserWalletDesktop buttonSize="sm"/>)
          }
        </Flex>
      </Flex>
    </Box>
  );
};

export default React.memo(NavigationDesktop);
